// extracted by mini-css-extract-plugin
export var accentColor = "var(--color-accent)";
export var categoryBorderColor = "var(--color-border)";
export var disableRipple = "true";
export var fontFamily = "var(--font-family)";
export var mainColor = "#12b886";
export var mainContrast = "rgba(0,0,0,.87)";
export var panelBorderColor = "var(--color-border)";
export var secondaryColor = "#4c6ef5";
export var secondaryContrast = "#fff";